import {
  FETCH_EVENTS, FETCH_ACTIVE_EVENTS, FETCH_EVENT, FETCH_REASONS_TO_ATTEND, FETCH_VENUE,
  FETCH_VENUE_CITY_IMAGES, KNOWLEDGE_SHARING_SESSION,
  STRATEGIC_SPONSORS, PARALLEL_EVENTS, ACCOMMODATIONS,
  SPEAKERS_LIST, EXHIBITORS, MEDIA, MEETING_ROOMS, PARTICIPANT_MEMBERS, PARTICIPANT_COMPANIES,
  EVENT_PRICES, AWARD_PRICES, FETCH_PREVIOUS_EDITION, FETCH_EVENT_ALL_SPONSORS,
  BOOKED_TABLES,
} from './types';

export default {
  [FETCH_EVENTS]: (state, payload) => {
    const events = payload.events.sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime());
    state.events = events;
  },
  [FETCH_ACTIVE_EVENTS]: (state, payload) => {
    const events = payload.activeEvents.sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime());
    state.activeEvents = events;
  },
  [FETCH_EVENT]: (state, payload) => {
    state.event = payload.event;
  },
  [FETCH_PREVIOUS_EDITION]: (state, payload) => {
    state.prevEvent = payload.prevEvent;
  },
  [FETCH_REASONS_TO_ATTEND]: (state, { reasons = [] }) => {
    state.reasons = reasons.reverse();
  },
  [FETCH_VENUE]: (state, payload) => {
    state.venue = payload.venue;
  },
  [FETCH_VENUE_CITY_IMAGES]: (state, payload) => {
    state.venueCityImages = payload.venueCityImages;
  },
  [KNOWLEDGE_SHARING_SESSION]: (state, payload) => {
    state.session = payload.session;
  },
  [STRATEGIC_SPONSORS]: (state, payload) => {
    state.sponsors = payload.sponsors;
  },
  [FETCH_EVENT_ALL_SPONSORS]: (state, { sponsors }) => {
    state.eventAllSponsors = sponsors;
  },
  [PARALLEL_EVENTS]: (state, payload) => {
    state.parallelEvents = payload.parallelEvents;
  },
  [ACCOMMODATIONS]: (state, payload) => {
    state.accommodations = payload.accommodations;
  },
  [SPEAKERS_LIST]: (state, payload) => {
    const sortedList = {
      keynoteSpeakers: [],
      panelist: [],
      moderators: [],
    };
    payload.speakersList.forEach((elem) => {
      if (elem.type === 'keynote_speaker') sortedList.keynoteSpeakers.push(elem);
      if (elem.type === 'panelist') sortedList.panelist.push(elem);
      if (elem.type === 'moderator') sortedList.moderators.push(elem);
    });
    state.speakersList = sortedList;
  },
  [EXHIBITORS]: (state, payload) => {
    state.exhibitors = payload.exhibitors;
  },
  [BOOKED_TABLES]: (state, payload) => {
    state.bookedTables = payload.bookedTables;
  },
  [MEDIA]: (state, payload) => {
    state.mediaDocs = payload.mediaDocs;
  },
  [MEETING_ROOMS]: (state, payload) => {
    state.meetingRooms = payload.meetingRooms;
  },
  [PARTICIPANT_MEMBERS]: (state, payload) => {
    const { count, results } = payload.data;
    state.participantMembers = [...state.participantMembers, ...results];
    state.participantMembersCount = count;
  },
  [PARTICIPANT_COMPANIES]: (state, payload) => {
    const { results } = payload.data;
    const newResults = results.map(res => ({ ...res, name: res.details.name }));
    state.participantCompanies = [...state.participantCompanies, ...newResults];
  },
  [EVENT_PRICES]: (state, payload) => {
    state.eventPrices = payload.eventPrices;
  },
  [AWARD_PRICES]: (state, payload) => {
    state.awardPrices = payload.awardPrices;
  },
};
